import { Navigate } from "react-router-dom";
import { useSessionStore } from "../store/sessionStore";

export default function PublicRoutes({children}) {
  const { login } = useSessionStore();

  return (!login)
  ? children
  : <Navigate to="/dashboard" />
}
